import { Model, stringifyGraph } from '@/clients/http'

import { UserHttpParams } from '@/types/http-params/UserHttpParams'
import { UserResponses } from '@/types/http-responses/UserResponses'

export class UserModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'GET_ADMIN_LIST',
    GET_BY_ID: 'GET_ADMIN_BY_ID',
    CREATE: 'CREATE_ADMIN',
    UPDATE: 'UPDATE_ADMIN',
    // DELETE: 'DELETE_ADMIN',
  }

  public static readonly endpoints = {
    getList: (props?: UserHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/admin',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: UserHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/admin/:id',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: UserHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/admin',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: UserHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/admin/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: UserHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/admin/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (props?: UserHttpParams.GetList) => {
    return this.createHttpRequest<UserResponses.GetList, UserResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly getById = async (props: UserHttpParams.GetById) => {
    return this.createHttpRequest<UserResponses.GetById, UserResponses.GetByIdError>({
      correlationKey: this.correlations.GET_BY_ID,
      payload: {
        method: 'get',
        url: this.endpoints.getById(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly create = async (props: UserHttpParams.Create) => {
    return this.createHttpRequest<UserResponses.Create, UserResponses.CreateError>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  public static readonly update = async (props: UserHttpParams.Update) => {
    return this.createHttpRequest<UserResponses.Update, UserResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  //   public static readonly delete = async (props: UserHttpParams.Delete) => {
  //     return this.createHttpRequest<UserResponses.Delete, UserResponses.DeleteError>({
  //       correlationKey: this.correlations.DELETE,
  //       payload: {
  //         method: 'delete',
  //         url: this.endpoints.delete(props),
  //         useBearerToken: true,
  //       },
  //       store: props?.store,
  //     })
  //   }
}
